import React, { useContext } from "react";
import { MenuContext } from "../MenuManager";
import classNames from "classnames";

import "./style.scss";

export default function MenuButton() {
  const { setOpen, open } = useContext(MenuContext);

  return (
    <div className={classNames("menu-button-wrap", { open })}>
      <button className="menu-button" onClick={() => setOpen(!open)}>
        <span />
      </button>
    </div>
  );
}